<a
  class="cursor-pointer"
  [ngbPopover]="networkDelayTable"
  [popoverTitle]="'label.networkDelayTable' | translate"
>{{'label.networkDelayTable' | translate}}</a>
<ng-template #networkDelayTable>
  <div class="table-responsive">
    <table class="table table-sm table-scroll">
      <thead>
        <tr>
          <th>{{'label.network' | translate}}</th>
          <th>{{'label.cdrDataDelay' | translate}}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let delay of dataDelays">
          <td>{{delay.network}}</td>
          <td>{{delay.time}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</ng-template>
